export const NoneImage = "data:image/png;base64,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";

// format: 'yyyy-mm-dd hh:ii:ss'
// date: new Date() | null
export const DateTimeFormat = (format, date) => {
    if (date == null) {
        date = new Date();
    }
    var o = {
        "m+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "i+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds(), //毫秒
    };
    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
    }
    return format;
};

// 格式化日期
export const toDate = (milliseconds) => {
    let date = new Date(parseInt(milliseconds));
    if(isNaN(date)){ return '0' }
    let Y = date.getFullYear() + '-';
    let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
    let D = date.getDate();
//     let h = date.getHours() + ':';
//     let m = date.getMinutes() + ':';
//     let s = date.getSeconds();
    return Y + M + D;
}

export const RandomString = (length) => {
    length = length || 32;
    let t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
    let a = t.length;
    let n = "";
    for (let i = 0; i < length; i++) n += t.charAt(Math.floor(Math.random() * a));
    return n;
};

export const ObjectMap = (fn, obj, filterNull) => {
    let arr = [];
    for (let x in obj) {
        if (filterNull && (obj[x] === null || obj[x] == undefined || obj[x].length == 0)) {
            continue;
        }
        arr.push(fn(x, obj[x]));
    }
    return arr;
};

// k-v obj 转下拉框 option 列表
export const ObjToSelectOption = (obj, withBlank=true, keyFunc = x => parseInt(x)) => {
    let values = Object.keys(obj);
    let list = values.map(k => {return {label: obj[k], value: keyFunc(k)}});
    if(withBlank) {
        list = [{label:"", value:""}].concat(list)
    }
    return list
};

// test var mainNodeList = [
//     {name: 'a', meta: 'x', children: [{name:'aa', meta:'a1', children: []}, {name:'ab', meta:'a2', children:[]}]},
//     {name: 'b', meta: 'y', children: [{name:'ba', meta:'b1', children: []}, {name:'bb', meta:'b1', children:[]}]},
//     {name: 'c', meta: 'z', children: [{name:'ca', meta:'c1', children: []}, {name:'cb', meta:'c2', children:[]}]},
// ];

// test var allowNodeList = [
//     {name: 'a', children: [{name:'aa', children: []}, {name:'ab', children:[]}]},
//     {name: 'c', children: [{name:'cb', children: []}]},
// ];

// Usage(layout/Main.vue):
//      const router = useRouter();
//      let app = getCurrentInstance();
//      if(app.appContext.config.globalProperties.$myRoutes == undefined) {
//          let myroutes = GetLocalStorageT(STORE_KEY_ADMIN_ROUTE);
//          if(myroutes == undefined || myroutes == null || (Object.prototype.toString.call(myroutes) == '[object Array]' && myroutes.length == 0)) {
//              GlobalMessage.error('数据错误，请重新登录');
//              router.replace('/logout');
//              router.go(0);
//              return;
//          }
//          app.appContext.config.globalProperties.$myRoutes = myroutes;
//      }
//      FilterRouters(app.appContext.config.globalProperties.$router.options.routes, app.appContext.config.globalProperties.$myRoutes);

export function FilterRouters(mainNodeList, allowNodeList) {
    for (let i = 0; mainNodeList != undefined && i < mainNodeList.length; i++) {
        let notExist = true;
        for (let j = 0; allowNodeList != undefined && j < allowNodeList.length; j++) {
            if(mainNodeList[i].name === allowNodeList[j].name) {
                notExist = false;
                mainNodeList[i].meta['childs'] = allowNodeList[j].children.map(item => item.name);// 子路由name列表
                FilterRouters(mainNodeList[i].children, allowNodeList[j].children);
                break;
            }
        }
        if(notExist) {
            mainNodeList.splice(i, 1);
            i--;
        }
    }
}

export function getRouteChilds(router,route){
    if(route.meta.childs) return route.meta.childs;
    let parentRoute = router.find(x => x.name == route.meta.parent);
    let newRoute = parentRoute.children.find(x => x.name == route.name);
    return newRoute.meta.childs;
}